<template>
    <v-container >
        <app-header  v-if="headerState" :hideTitle="!titleState">
            <span slot="title">DWI</span>
        </app-header>
        <v-row>
            <v-col cols="8">
                <v-text-field
                    placeholder="Name"
                    append-icon="mdi-magnify"
                    v-model="payloadName"
                >
                <template v-slot:append>
                        <v-icon   v-show="payloadName" @click="payloadName=''">
                          {{'mdi-close'}}
                        </v-icon>
                        <v-progress-circular v-show="queryLoading" :size="24" indeterminate></v-progress-circular>
                        <v-icon   v-show="!queryLoading" @click="queryDWI" :disabled="!mmsReady">
                          {{'mdi-magnify'}}
                        </v-icon>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="4">
                <v-select
                v-model="selectedItem"
                :items="queryResult"
                item-text="id"
                return-object
                />
            </v-col>
            <v-col cols="12" v-if="selectedItem">
                <v-card>
                    <v-row>
                        <v-col
                        v-for="(item,index) in selectedItem"
                        :cols="6"
                        class="pl-8"
                        :key="index">
                            {{`${queryResultTitle.get(index)} : ${item}`}}
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import conf from "@/config/config";
import {
  set as setCookie,
  get as getCookie
} from "es-cookie";
import webmms from "webmms-client";
export default {
    name:"DWI",
    props: ['pageParams'],
    data(){
        return {
            queryLoading:false,
            selectedItem:null,
            queryResult:[],
            queryResultTitle:new Map([['id','Id'],['x_a_total','Sharing'],['x_b_total','Productivity'],['x_c_total','Reporting'],['x_d_total','Collaboration'],['x_total','Total']]),
            payloadName:'',
            errorMsg: "",
            errorLoading: false,
            params: null,
            error: true,
            errorLoading: false,
            msg: "",
            err:"",
            mmsReady: false,
            mms: null,
            eiInfo: {
              eiName: "",
              eiTag: "",
              ddn: ""
            },
            EiToken:null,
            SToken:null,
            webmmsOptions:{
              EiToken:"",
              SToken:"",
              UToken:""
            },
            topic:"",
            payload:null,
            func:null
        }
    },
    computed:{
      ...mapGetters([
        'headerState',
        'footerState',
        'titleState'
      ])
    },
    mixins:[],
    watch:{
        async mmsReady(val){
            if(val){

            }
        },
        selectedItem(val){
            //console.log(val);
        }
    },
    methods:{
        async queryDWI(){
            this.queryLoading=true;
            let reply = await this.mms.callMMS({
                        DDN : '>>>h3/eip/odoo-bridge-eip-app',
                        topic : 'odoo://portal',
                        func: 'search_read',
                        payload: [
                              "x_dwi",
                            [['x_name','=',this.payloadName]],
                            ['x_a_total','x_b_total','x_c_total','x_d_total','x_total']
                        ]
                    });
                    this.queryLoading=false;
                    console.log(reply);
                    this.queryResult=reply[0].Reply;
        },
        async subscribeMMS() {
            this.removeEvent = this.mms.on("registered", async reply => {
            if(process.env.NODE_ENV!= 'production')
              console.log('reply=%s', JSON.stringify(reply))
            if (reply.ErrMsg == "OK") {
              this.eiInfo.ddn = reply.result.DDN;
              this.webmmsOptions.EiToken = reply.result.EiToken;
              this.webmmsOptions.SToken = reply.result.SToken;
              this.webmmsOptions.UToken = reply.result.UToken;
              if (this.eiInfo.eiName == "") {
                this.eiInfo.eiName = reply.result.EiName
                  ? reply.result.EiName
                  : "jb" + this.makeId(5);
              }
              if (this.eiInfo.eiTag == "") {
                this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : "";
              }
              this.mmsReady = true;
              this.error = false;
            } else {
              this.mmsReady = false;
              this.error = false;
            }

            setCookie("EiToken", this.webmmsOptions.EiToken);
            setCookie("SToken", this.webmmsOptions.SToken);

            console.log("regtoCenter: %s", reply.ErrMsg);

            let deviceInfo = {
              DDN: this.eiInfo.ddn,
              EiOwner: "",
              EiName: this.eiInfo.eiName,
              EiType: ".page",
              EiTag: this.eiInfo.eiTag,
              EiLoc: ""
            };
            let result = await this.mms.setDeviceInfo(deviceInfo);

            console.log(`SetDevice reply=${JSON.stringify(result)}`);
            await this.track(this.mms, 'dwi', this.pageParams);
        });

        this.mms.on("message", (method, from, data, body) => {
          this.mmsReady = true;
          this.error = false;
          console.log(`rcve: from=${JSON.stringify(from)}, data=${data}`);
          this.msg=`
               method: ${method}
               from: ${JSON.stringify(from)}
               data: ${data}
               ack: ${body}
           `
          //body();
          if (typeof data == "object" && !data.from) data.from = from;
          //body.sender = data;
          if (data) {
            //this.eventList.push(data.data);
            //this.setLog({From : from, Data: data}, 'In');
          }
        });

        this.mms.on("state", msg => {
          console.log("WS error: %s", msg);
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("disconnect", msg => {
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("error", err => {
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("connect_error", err => {
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("connect_timeout", err => {
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });
      }
    },
    async created(){
      this.EiToken=getCookie('EiToken')||'';
      this.SToken=getCookie('SToken')||'';
      this.mms=webmms({wsurl:conf.wsurl,EiToken:this.EiToken,SToken:this.SToken});
    },
    async beforeMount() {
      await this.subscribeMMS();
    },
    beforeDestroy() {
      this.removeEvent();
    }
}
</script>
